/**
 * Harbour cheap-name / paid-gap search helpers.
 * One completed name or gap hit opens the briefing. A 20-hit facet list does not.
 */

export function getHarbourSoleSearchHit({
  query,
  gap,
  completedQuery,
  completedGap,
  venues,
  loading,
  error,
} = {}) {
  if (loading || error) {
    return null
  }

  const search = String(query || '').trim()
  const facet = String(gap || '').trim()
  if (!search && !facet) {
    return null
  }
  if (search !== String(completedQuery || '').trim()) {
    return null
  }
  if (facet !== String(completedGap || '').trim()) {
    return null
  }

  if (!Array.isArray(venues) || venues.length !== 1) {
    return null
  }

  const venue = venues[0]
  return venue?.venueId ? venue : null
}
